import jsrsasign from 'jsrsasign'

function getSign(text) {
  let pri =
    'MIICdwIBADANBgkqhkiG9w0BAQEFAASCAmEwggJdAgEAAoGBAOq5d+c0eVZ+1260LpC9xawu34PrXdkMxKgh1Lzg+cUujZP/mC1hE0enN+3r5RbQEyMmVhvBfY3sA6y8bD0YW6ar6eHZ02Q1CZD0BYG6xRrG7AA25Zsxj1PVB32lrki5Or+5ORYAs2SwaH2YOTneU6rE92oNOVAJxFkkDZBDLP6fAgMBAAECgYAIZSnMsyvD1DWQWBFyS9dOGT8VUM3CfZprCQq61rEYRFn7+SBQPzCZV3nAoLdI4ZhNoYli5MDA2rgm7XZRmRVuBx8VmV39B5aY0d3W4mrGH8E9hZ1WfFj96zAsMGwvGV8DiYgBF+lJ4KzWpWc8LX5InacrkCMhfRNkip3nGSVIgQJBAPVAbDWr9r0EHzcyIJWnQRDlNG3PGWBuWDJgtIG2i1t6+CSiHPhmKlPIhDhLk5xIm8WdiPHaHxg5SaKVIgQF0LkCQQD1Au/pqOnNP/BgW5kI+fgD22hOdGvKMjW31EmDKZgQMbNs4rMk39FNCcS06RuxnE15sf4D7I5otbI8LfolVi4XAkEAsJFMFqwSvOyNyMBHI1dCCfbqczBJ9dobl1F2Q3j4BcmXg1BPiSqMyLsxLhKDWF4SAAk2AeFmx5re/7VcwwaoyQJASxpoYi6F5IWZ8F+DjI3bKYuC8LGdLPCxKLVpB0yjsSsa/eCL21zEMqIw6uedtpbb5Nbbr2Y+zPgNN4c8a198ZwJBANF69UgXqtZ0s8qxATENeYSIlcoJfZDJJnQ6tWOjAB7Ed1swu2DmHxk2+0FfEeb6X1bBXGdYZEVkblBJudM5Gk4='
  let priKey = `-----BEGIN PRIVATE KEY-----${pri}-----END PRIVATE KEY-----`
  let signKey = jsrsasign.KEYUTIL.getKey(priKey)
  let signature = new jsrsasign.KJUR.crypto.Signature({ alg: 'SHA256withRSA' })
  signature.init(signKey)
  signature.updateString(text)
  let signResult = encodeURIComponent(jsrsasign.hextob64(signature.sign()))
  return signResult
}

export default getSign
